export const GLOBAL_ROLES = {
  INTERNAL: 'internal',
  NULL: null,
  // Add more roles as needed
} as const;

export type GlobalRole = (typeof GLOBAL_ROLES)[keyof typeof GLOBAL_ROLES];
